import { notifications } from '@mantine/notifications';
import { pipe } from 'remeda';

import {
  buildGeneratedFormValues,
  extractGeneratedSteps,
  normalizeGeneratedSteps,
  resetAndValidate,
} from '../shared';
import { type ConfigGeneratedHandlerDependencies } from './types';

export function createConfigGeneratedHandler({
  experienceForm,
  setExperienceConfigId,
  setIsExperienceFormDirty,
}: ConfigGeneratedHandlerDependencies) {
  return (
    config: unknown,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _descriptions: {
      title: string;
      shortDescription: string;
      description: string;
    }
  ) => {
    if (!config) {
      return;
    }

    const normalizedSteps = pipe(
      extractGeneratedSteps(config),
      normalizeGeneratedSteps
    );

    const formValues = buildGeneratedFormValues({
      config,
      normalizedSteps,
    });

    void resetAndValidate(experienceForm, formValues);
    setIsExperienceFormDirty(false);
    setExperienceConfigId(null);

    notifications.show({
      color: 'green',
      title: 'Configurazione caricata',
      message:
        'La configurazione generata è stata caricata nel form. Puoi modificarla se necessario.',
    });
  };
}
